import React from 'react';
import './PrivacyPolicy.css';
import Footer from '../components/home/Footer';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="policy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: April 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            CofounderHubs ("we," "us," "our," or "Company") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect information about you in a variety of ways. The information we may collect on the Site includes:</p>
          <ul>
            <li><strong>Personal Data:</strong> Name, email address, phone number, profile information, and other details you provide when registering or using our services.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and actions taken.</li>
            <li><strong>Device Information:</strong> Information about your device, browser type, IP address, and operating system.</li>
            <li><strong>Cookies and Tracking:</strong> We use cookies and similar tracking technologies to enhance your experience.</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect for various purposes:</p>
          <ul>
            <li>To provide and maintain our services</li>
            <li>To notify you about changes to our services</li>
            <li>To allow you to participate in interactive features</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information to improve our services</li>
            <li>To monitor the usage of our services</li>
            <li>To detect, prevent, and address technical and security issues</li>
          </ul>
        </section>

        <section>
          <h2>4. Disclosure of Your Information</h2>
          <p>
            We may share your information in the following situations:
          </p>
          <ul>
            <li><strong>By Law or to Protect Rights:</strong> If required by law or if we believe in good faith that disclosure is necessary to protect our rights, your safety, or the safety of others.</li>
            <li><strong>Third-Party Service Providers:</strong> We may share your information with third parties who perform services on our behalf.</li>
            <li><strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or asset sale, your information may be transferred as part of that transaction.</li>
          </ul>
        </section>

        <section>
          <h2>5. Security of Your Information</h2>
          <p>
            We use administrative, technical, and physical security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is completely secure.
          </p>
        </section>

        <section>
          <h2>6. Contact Us</h2>
          <p>
            If you have questions or comments about this Privacy Policy, please contact us at:
          </p>
          <p>
            Email: hr@cofounderhubs.com
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
